import React, { memo, Fragment } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import listPlugin from "@fullcalendar/list";

import { Loading } from '../../common/parts/Loading';
import { PopoverText } from '../../common/parts/PopoverText';
import { formatUtcDatetime, formatUtcDatetimeDisplay } from '../../../services/calendar';

import { confirmState } from '../../../store/confirmState';
import { loadingState } from '../../../store/loadingState';
import { orderState } from '../../../store/orderState';
import { courceItemState } from '../../../store/courceItemState';

export const FormCalendar = memo((props) => {
  const isConfirm = useRecoilValue(confirmState);
  const [loading, setLoading] = useRecoilState(loadingState);
  const [orderData, setOrderData] = useRecoilState(orderState);
  const [courceItemData, setCourceItemData] = useRecoilState(courceItemState);

  const eventClickEvent = (e) => {
    setOrderData({
      ...orderData,
      examdt: formatUtcDatetime(e.event.start),
      item_id: parseInt(e.event.id, 10),
    });
  }

  const fullCalendarDisplay = () => {
    return (
      <Fragment>
        {!isConfirm &&
          <FullCalendar
            locale="ja"
            timeZone="Asia/Tokyo"
            plugins={[dayGridPlugin, listPlugin, ]}
            initialView="dayGridMonth"
            headerToolbar={{
              start: 'dayGridMonth,listMonth',
              center: 'title',
              end: 'prev,next',
            }}
            buttonText={{
              prev: '<',
              next: '>',
              month: '月',
              list: 'リスト'
            }}
            events={courceItemData}
            eventColor="#fff"
            nowIndicator
            eventClick={(e) => eventClickEvent(e)}
          />
        }
      </Fragment>
    )
  }

  return (
    <>
      <p className="h3">受診予約日時 
        <PopoverText textTitle="受診希望日" textBody="ご希望の受診希望日が〜〜〜、調整のご連絡を差し上げます。" />
      </p>
      { loading ? 
        <div className="mb-3"><Loading /></div>
      : 
        <Fragment>{ fullCalendarDisplay() }</Fragment> 
      }

      {orderData.examdt &&
        <div className="card bg-light mb-3">
          <div className="card-header fw-bold">選択した受診予約日時</div>
          <div className="card-body fw-bold">
            { formatUtcDatetimeDisplay(orderData.examdt) }
          </div>
        </div>
      }
    </>
  );
});